import React from 'react';
import { Plus } from 'lucide-react';

export const AdminAddButton = ({ onClick, label, icon: Icon = Plus }) => (
  <button
    onClick={onClick}
    type="button"
    className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-semibold rounded-xl text-white bg-blue-600 hover:bg-blue-700 transition-all duration-200 shadow-sm"
  >
    <Icon className="h-4 w-4 mr-2" />
    {label || 'Add'}
  </button>
);
